@if (corporateTaxEntity$ | async) {
<form [formGroup]="balansEnResultatenRekeningFg">

  <div class="d-flex mb-2" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px;"></div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2">
        <p style="width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin: 0;">{{ item.value.naamVennootschap }}</p>
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Gestort kapitaal</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="gestortEnOpgevraagdKapitaal">
        @for (_ of item.get('gestortEnOpgevraagdKapitaal')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="gestortEnOpgevraagdKapitaal"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Informeel kapitaal</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="informeelKapitaal">
        @for (_ of item.get('informeelKapitaal')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="informeelKapitaal"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Agioreserve</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="agioreserve">
        @for (_ of item.get('agioreserve')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="agioreserve"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Winstreserves</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="winstreserves">
        @for (_ of item.get('winstreserves')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="winstreserves"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Kostenegalisatiereserve</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="kostenEgalisatieReserve">
        @for (_ of item.get('kostenEgalisatieReserve')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="kostenEgalisatieReserve"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Herinvesteringsreserve</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="herinvesteringsReserve">
        @for (_ of item.get('herinvesteringsReserve')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="herinvesteringsReserve"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Overige reserves</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="overigeReserves">
        @for (_ of item.get('overigeReserves')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
            class="custom-input-150"
            [prefix]="i === index - 2 ? '€  -' : '€'"
            [showAllDecimals]="false"
            align="right"
            formControlName="openingsbalans"
            id="overigeReserves"
            [disabledControl]="i === index - 1">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Garantievoorziening</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="garantieVoorzieningen">
          @for (_ of item.get('garantieVoorzieningen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="garantieVoorzieningen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Oudedagsvoorzieningen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="oudedagsVoorzieningen">
          @for (_ of item.get('oudedagsVoorzieningen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="oudedagsVoorzieningen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige voorzieningen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="overigeVoorzieningen">
          @for (_ of item.get('overigeVoorzieningen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="overigeVoorzieningen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Pensioenverplichtingen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="pensioenVoorzieningen">
          @for (_ of item.get('pensioenVoorzieningen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="pensioenVoorzieningen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopend schulden groepsmaatschappijen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenLanglopendGroepsmaatschappijen">
          @for (_ of item.get('schuldenLanglopendGroepsmaatschappijen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenLanglopendGroepsmaatschappijen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende schulden participanten</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenLanglopendParticipanten">
          @for (_ of item.get('schuldenLanglopendParticipanten')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenLanglopendParticipanten"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende schulden kredietinstellingen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenLanglopendKredietinstellingen">
          @for (_ of item.get('schuldenLanglopendKredietinstellingen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenLanglopendKredietinstellingen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige langlopende schulden</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenLanglopendOverig">
          @for (_ of item.get('schuldenLanglopendOverig')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenLanglopendOverig"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Crediteuren</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="crediteuren">
          @for (_ of item.get('crediteuren')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="crediteuren"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Omzetbelasting</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenOmzetbelasting">
          @for (_ of item.get('schuldenOmzetbelasting')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenOmzetbelasting"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Loonheffingen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenLoonheffingen">
          @for (_ of item.get('schuldenLoonheffingen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenLoonheffingen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende schulden groepsmaatschappijen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenKortlopendGroepsmaatschappijen">
          @for (_ of item.get('schuldenKortlopendGroepsmaatschappijen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenKortlopendGroepsmaatschappijen"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende schulden participanten</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenKortlopendParticipanten">
          @for (_ of item.get('schuldenKortlopendParticipanten')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenKortlopendParticipanten"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige kortlopende schulden</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="schuldenKortlopendOverig">
          @for (_ of item.get('schuldenKortlopendOverig')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
              class="custom-input-150"
              [prefix]="i === index - 2 ? '€  -' : '€'"
              [showAllDecimals]="false"
              align="right"
              formControlName="openingsbalans"
              id="schuldenKortlopendOverig"
              [disabledControl]="i === index - 1">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p><b>Totaal passiva</b></p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="totaal">
          @for (_ of item.get('totaal')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <div>
              <snelstart-ui-number-form-control
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150 custom-readonly"
                formControlName="totaalPassivaOpen"
                id="totaal"
                prefix="€">
              </snelstart-ui-number-form-control>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

</form>
}
